// Content blocks: FAQ accordion and SEO read-more toggle
export default function () {

    const $ = jQuery;

    $('.block__contact-faq-item').each(function () {
        const $details = $(this);
        const $summary = $details.find('summary');
        const $content = $details.find('.block__contact-faq-answer');

        // Start gesloten
        $content.hide();

        $summary.on('click', function (e) {
            e.preventDefault();

            const isOpen = $details.attr('open') !== undefined;

            // Sluit alle andere items
            $('.block__contact-faq-item').each(function () {
                const $other = $(this);
                if ($other[0] !== $details[0]) {
                    $other.find('.block__contact-faq-answer').slideUp(300);
                    $other.removeAttr('open');
                }
            });

            if (isOpen) {
                // Eerst animeren, daarna `open` attribuut weghalen
                $content.slideUp(300, function () {
                    $details.removeAttr('open');
                });
            } else {
                $details.attr('open', true);
                $content.slideDown(300);
            }
        });
    });

    $('[data-action="seo_readmore"]').on('click', function (event) {
        event.preventDefault(); // prevent default link behavior
        $(this).closest('.container').find('.block__seo-items').toggleClass('is-active');
        $(this).toggleClass('is-active');
    });

}
